
export default function AuthButton(props: { clickHandler: () => void, isLoading : boolean, text: string}){
    const { clickHandler, isLoading, text } = props ;
    return (
        <button onClick={clickHandler} className={isLoading ? "loading" : ""}>
            {
                isLoading ? 
                    <div className="animate-spin w-[25px] h-[25px]">
                        <svg fill={"#ffffff"} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4287" width="25" height="25"><path d="M96 512c0-19.33 15.67-35 35-35s35 15.67 35 35c0 191.09 154.91 346 346 346s346-154.91 346-346-154.91-346-346-346c-19.33 0-35-15.67-35-35s15.67-35 35-35c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512z" p-id="4288"></path></svg>
                    </div>
                : text
            }
        </button>
    )
}